import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=6a0d44ad&scoped=true&"
import script from "./deleteDialog.vue?vue&type=script&lang=js&"
export * from "./deleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteDialog.vue?vue&type=style&index=0&id=6a0d44ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d44ad",
  null
  
)

export default component.exports